var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-4 col-sm-5 p-2 titleBlock"},[_vm._v("\r\n            "+_vm._s(_vm._f("decoder")(_vm.title))+"\r\n        ")]),_vm._v(" "),_c('div',{staticClass:"pt-3",attrs:{"id":"text-head"}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.decoder(_vm.subtitle))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.decoder(_vm.text))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cba70f5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overall_layouts/bbnc-content.vue
// module id = 651
// module chunks = 0